import { AvatarCharecter, AvatarImage } from 'components';
import { Clock, FileText, MoreHorizontal, Move, Target } from 'lucide-react';
import React from 'react'
import { getActionIcon, repareURL } from 'utils';
import { formatTimeAgo } from 'utils/time_helpers';

const getActionText = (action) => {
    const textMap = {
        created: "Tạo mới",
        updated: "Cập nhật",
        deleted: "Xóa",
        moved: "Di chuyển"
    };
    return textMap[action] || action;
};

const getActionColor = (action) => {
    const colorMap = {
        created: "text-green-600 bg-green-50",
        updated: "text-blue-600 bg-blue-50",
        deleted: "text-red-600 bg-red-50",
        moved: "text-purple-600 bg-purple-50"
    };
    return colorMap[action] || "text-gray-600 bg-gray-50";
};


export const ActivityCard = ({ activity }) => (
    <div className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-all duration-200">
        <div className="flex items-start gap-4">
            {/* Avatar */}
            <div className="flex-shrink-0">
                {activity.user.avatar ?
                    <AvatarImage className="w-10 h-10 rounded-full" src={repareURL(activity.user.avatar)} alt={activity.user?.name} /> : <AvatarCharecter className="w-10 h-10" name={activity.user?.name} />}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        {getActionIcon(activity.action, activity.target_type)}
                        <span className="font-medium text-gray-900 text-sm">
                            {activity.user.name}
                        </span>
                        <span className={`px-2 py-1 rounded-md text-xs font-medium ${getActionColor(activity.action)}`}>
                            {getActionText(activity.action)}
                        </span>
                        <span className="text-gray-500 text-sm">
                            {activity.target_type}
                        </span>
                    </div>
                    <button className="p-1 hover:bg-gray-100 rounded">
                        <MoreHorizontal className="w-4 h-4 text-gray-400" />
                    </button>
                </div>

                <div className="mb-2">
                    <h3 className="font-medium text-gray-900 mb-1">{activity.target}</h3>
                    <p className="text-gray-600 text-sm line-clamp-2">{activity.description}</p>
                </div>

                {/* Metadata */}
                <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500 mb-2">
                    <span className="flex items-center gap-1">
                        <Target className="w-3 h-3" />
                        {activity.project?.name}
                    </span>
                    <span className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        {formatTimeAgo(activity.timestamp)}
                    </span>
                    <span className="flex items-center gap-1">
                        <FileText className="w-3 h-3" />
                        ID: {activity.target_id}
                    </span>
                </div>

                {/* Action specific info */}
                {activity.action === 'moved' && activity.description.includes('moved from') && (
                    <div className="flex items-center gap-2 text-xs">
                        <span className="px-2 py-1 bg-orange-50 text-orange-700 rounded">
                            {activity.description.match(/moved from (\w+)/)?.[1] || 'Unknown'}
                        </span>
                        <Move className="w-3 h-3 text-gray-400" />
                        <span className="px-2 py-1 bg-green-50 text-green-700 rounded">
                            {activity.description.match(/to (\w+)/)?.[1] || 'Unknown'}
                        </span>
                    </div>
                )}
            </div>
        </div>
    </div>
);